import CookieRepository from "core/data/CookieRepository";
import i18n from "utils/i18n";

class cookieManager {
	get(name: string) {
		return CookieRepository.GetCookie({
			Value: name,
			culture: i18n.language,
		});
	}

	set(name: string, value: string) {
		(async () => {
			await CookieRepository.SetCookie(name, value);
		})();
	}
}
var CookieManager = new cookieManager();
export default CookieManager;
